<template>
	<div class="homebody">
		<div class="content1"></div>
		<div class="content2">
			<div class="content2-title">多款产品  供您选择</div>
			<div class="content2-title2">
				——  VARIETY OF PRODUCTS FOR YOU TO CHOOSE ——
			</div>
			<img class="img1" src="../assets/content1.png">
			<img class="img2" src="../assets/content1.png">
			<img class="img3" src="../assets/content1.png">
			<img class="img4" src="../assets/content1.png">
			<img class="img5" src="../assets/content1.png">
			<img class="img6" src="../assets/content1.png">
			<img class="img7" src="../assets/content1.png">
			<img class="img8" src="../assets/content1.png">
			<div class="desc1">六口机柜充电宝
				<div class="subdesc">价格合理 性价比高</div>
			</div>
			<div class="desc2">九口机柜充电宝
				<div class="subdesc">价格合理 性价比高</div>
			</div>
			<div class="desc3">十二口机柜充电宝
				<div class="subdesc">经典白色  充电宝充足</div>
			</div>
			<div class="desc4">六口广告机
				<div class="subdesc">占地面积小  广告随时打</div>
			</div>
			<div class="desc5">四十五口32寸屏大机柜
				<div class="subdesc">超大屏幕  广告充电一举两得</div>
			</div>
			<div class="desc6">三十口21.5寸屏大柜机
				<div class="subdesc">超大屏幕  广告充电一举两得</div>
			</div>
			<div class="desc7">二十七口32寸屏大机柜
				<div class="subdesc">超大屏幕  广告充电一举两得</div>
			</div>
			<div class="desc8">共享密码充电线
				<div class="subdesc">小巧玲珑  携带方便</div>
			</div>
		</div>
		<div class="content3"></div>
		<div class="content4"></div>
	</div>
</template>

<script>
	export default{
		name: 'homebody'
	}
</script>

<style>
	.homebody{
		display: block;
		position: relative;
		width: 1920px;
		min-width: 1920px;
		height: 100%;
		margin: 0 auto;
	}
	.content1{
		width: 1920px;
		height: 540px;
		background-image: url(../assets/content1.png);
	}
	.content2{
		width: 1920px;
		height: 876px;
		/* background-color: darkgreen; */
	}
	.content2-title{
		display: inline-block;
		position: absolute;
		padding: 52px 758px 0px 763px;
		width: 399px;
		height: 46px;
		font-size: 46px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
	}
	.content2-title2{
		display: inline-block;
		position: absolute;
		margin: 114px 726px 0 729px;
		width: 465px;
		height: 15px;
		font-size: 18px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #909090;
	}
	.img1{
		display: inline-block;
		position: absolute;
		margin: 176px 1397px 0px 324px;
		width: 199px;
		height: 185px;
	}
	.img2{
		display: inline-block;
		position: absolute;
		margin: 177px 1002px 0px 640px;
		width: 278px;
		height: 182px;
	}
	.img3{
		display: inline-block;
		position: absolute;
		margin: 176px 701px 0px 1054px;
		width: 165px;
		height: 181px;
	}
	.img4{
		display: inline-block;
		position: absolute;
		margin: 174px 343px 0px 1417px;
		width: 160px;
		height: 188px;
	}
	.img5{
		display: inline-block;
		position: absolute;
		margin: 497px 1459px 0px 386px;
		width: 75px;
		height: 193px;
	}
	.img6{
		display: inline-block;
		position: absolute;
		margin: 497px 1108px 0px 749px;
		width: 63px;
		height: 193px;
	}
	.img7{
		display: inline-block;
		position: absolute;
		margin: 496px 745px 0px 1101px;
		width: 74px;
		height: 196px;
	}
	.img8{
		display: inline-block;
		position: absolute;
		margin: 542px 295px 0px 1368px;
		width: 257px;
		height: 111px;
	}
	.subdesc{
		margin: 14px auto;
		width: /* 114px */;
		height: 14px;
		font-size: 14px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #666666;
		line-height: 24px;
	}
	.desc1{
		display: inline-block;
		position: absolute;
		/* margin: 396px 1425px 0px 351px; */
		margin-top: 396px;
		margin-left: 351px;
		/* width: 150px; */
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc2{
		display: inline-block;
		position: absolute;
		margin-top: 396px;
		margin-left: 706px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc3{
		display: inline-block;
		position: absolute;
		margin-top: 396px;
		margin-left: 1054px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc4{
		display: inline-block;
		position: absolute;
		margin-top: 396px;
		margin-left: 1445px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc5{
		display: inline-block;
		position: absolute;
		margin-top: 721px;
		margin-left: 319px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc6{
		display: inline-block;
		position: absolute;
		margin-top: 721px;
		margin-left: 677px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc7{
		display: inline-block;
		position: absolute;
		margin-top: 721px;
		margin-left: 1032px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
	.desc8{
		display: inline-block;
		position: absolute;
		margin-top: 722px;
		margin-left: 1423px;
		height: 20px;
		font-size: 21px;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		color: #333333;
		line-height: 24px;
	}
</style>
